var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 180,
    viewBox: "0 0 156 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.607 180H103.134L64.17 104.463C51.856 80.5118 41.8393 59.8772 37.7959 49.3756H37.5201C37.9796 63.9304 37.9796 87.8813 37.9796 106.489V180H0.0264893V0H53.2344L98.9068 90.0921C107.913 107.963 113.978 122.794 118.021 131.638H118.297C117.837 116.807 117.562 98.9355 117.562 79.4985V0H155.515V180H155.607Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN);
export default __webpack_public_path__ + "static/media/n.69efd8b5e95b1988726b5690be97f171.svg";
export { ForwardRef as ReactComponent };